import React, { Component } from 'react'

// ui
import { Form, Avatar, Tooltip, Tag, Menu, Dropdown, Button, Icon } from 'antd'
import Editor from '../../../componentIsoMophic/ScrumBoard/Editor/editor'
import ReactQuill, { Quill } from 'react-quill'

// redux
import { connect } from 'react-redux'
import ReportActions from '../../../redux/report/actions'

// ui
import { FaTimes, FaPlus, FaSave, FaFileAlt } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import defaulObject from '../../../resource/image/objectDefault.png'

// sub component
import ListComment from './list_comments'

// export word, pdf
import { saveAs } from 'file-saver'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import htmlDocx from 'html-docx-js/dist/html-docx'
import defaultEvent from '../../../resource/image/imgEventDefaul.jpg'

const defaultAvatar = require('../../../resource/image/defaultAvatar.png')

const quillModules = {
    toolbar: false,
}

const exportToDocs = content => {
    let html = `<!DOCTYPE html>
        <html>
        <head>
        <meta charset="UTF-8">
        
        </head>
        <body>
        ${content}
        </body>
        </html>`
    const docx = htmlDocx.asBlob(html, {
        orientation: 'landscape',
        margins: { top: 720, right: 2000 },
    })
    saveAs(docx, 'download.docx')
}

const printDocument = () => {
    const input = document.getElementById('divToPrint')

    html2canvas(input).then(canvas => {
        const imgData = canvas.toDataURL('image/png')

        var imgWidth = 210
        var pageHeight = 295
        var imgHeight = (canvas.height * imgWidth) / canvas.width
        var heightLeft = imgHeight

        const pdf = jsPDF('p', 'mm', 'a4', true)
        var position = 3
        pdf.addImage(imgData, 'PNG', 5, position, imgWidth, imgHeight)
        heightLeft -= pageHeight
        while (heightLeft >= 0) {
            position = heightLeft - imgHeight
            pdf.addPage()
            pdf.addImage(imgData, 'PNG', 5, position, imgWidth, imgHeight)
            heightLeft -= pageHeight
        }

        pdf.save('download.pdf')
    })
}

class ReportInfoView extends Component {
    render() {
        const {
            report,
            user_has_read,
            selected_Media,
            selected_object,
            selected_event,
            selected_report,
            hashtag,
        } = this.props

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 4 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 20 },
            },
        }

        const menu = (
            <Menu>
                <Menu.Item key="1" onClick={() => printDocument()}>
                    Xuất ra định dạng pdf
                </Menu.Item>
                <Menu.Item key="2" onClick={() => exportToDocs(report.content)}>
                    Xuất ra định dạng docs
                </Menu.Item>
            </Menu>
        )

        return (
            <div>
                <Form {...formItemLayout}>
                    <Form.Item label="">
                        <Dropdown overlay={menu}>
                            <Button>
                                Xuất ra file <Icon type="down" />
                            </Button>
                        </Dropdown>
                    </Form.Item>
                    <Form.Item label="Tiêu đề">
                        <div style={{ color: 'black', fontWeight: 'bold' }}>
                            {report.title}
                        </div>
                    </Form.Item>
                    <Form.Item label="Tier báo cáo">
                        <div>{'Tier ' + report.tier_created}</div>
                    </Form.Item>
                    <Form.Item label="Người tạo">
                        <Avatar
                        src={report.owner && report.owner.avatar !== ''  ? report.owner.avatar : defaultAvatar}
                        alt="Avatar"
                        />
                        <span style={{ color: 'black', marginLeft: 5 }}>
                            {report.owner ? report.owner.display_name : ''}
                        </span>
                    </Form.Item>
                    <Form.Item label="Căn cứ">
                        <div>
                            <div>
                                {Array.isArray(selected_report) &&
                                selected_report.length > 0 ? (
                                    selected_report.map((data, index) => {
                                        return (
                                            <div>
                                                <a
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    href={`/app/qbreport/${data.fid}`}
                                                    style={{
                                                        padding: 5,
                                                        cursor: 'pointer',
                                                        color: 'black',
                                                    }}
                                                >
                                                    <FaFileAlt /> {data.title}
                                                </a>
                                            </div>
                                        )
                                    })
                                ) : (
                                    <div>Không</div>
                                )}
                            </div>
                        </div>
                    </Form.Item>
                    <Form.Item label="Sự kiện">
                        <div className="row">
                            {Array.isArray(selected_event) &&
                            selected_event.length > 0 ? (
                                selected_event.map((event, index) => {
                                    return (
                                        <Link
                                            to={`/app/qbevents/${event.event_id}`}
                                            target="_blank"
                                        >
                                            <Tooltip
                                                key={index}
                                                placement="top"
                                                title={event.name}
                                            >
                                                <img
                                                    style={{
                                                        height: 64,
                                                        width: 64,
                                                        margin: 3,
                                                        objectFit: 'cover',
                                                        borderRadius: 2,
                                                    }}
                                                    alt="img"
                                                    src={
                                                        event.avatar === ''
                                                            ? defaultEvent
                                                            : event.avatar
                                                    }
                                                />
                                            </Tooltip>
                                        </Link>
                                    )
                                })
                            ) : (
                                <div>Không</div>
                            )}
                        </div>
                    </Form.Item>
                    <Form.Item label="Đối tượng">
                        <div className="row">
                            {Array.isArray(selected_object) &&
                            selected_object.length > 0 ? (
                                selected_object.map((object, index) => {
                                    return (
                                        <Link
                                            to={`/app/qbobjects/${object.object_id}`}
                                            target="_blank"
                                        >
                                            <Tooltip
                                                key={index}
                                                placement="top"
                                                title={object.name}
                                            >
                                                <img
                                                    style={{
                                                        height: 64,
                                                        width: 64,
                                                        margin: 3,
                                                        objectFit: 'cover',
                                                        borderRadius: 2,
                                                    }}
                                                    alt="img"
                                                    src={
                                                        object.avatar !== ''
                                                            ? object.avatar
                                                            : defaulObject
                                                    }
                                                />
                                            </Tooltip>
                                        </Link>
                                    )
                                })
                            ) : (
                                <div>Không</div>
                            )}
                        </div>
                    </Form.Item>
                    <Form.Item label="Tài liệu">
                        <div>
                            {Array.isArray(selected_Media) &&
                            selected_Media.length > 0 ? (
                                selected_Media.map((media, index) => {
                                    return (
                                        <a
                                            rel="noopener noreferrer"
                                            href={media.url}
                                            target="_blank"
                                        >
                                            {media.name}
                                        </a>
                                    )
                                })
                            ) : (
                                <div>Không</div>
                            )}
                        </div>
                    </Form.Item>
                    <Form.Item label="Tag">
                        <div>
                            {Array.isArray(hashtag) && hashtag.length > 0 ? (
                                hashtag.map((tag, index) => {
                                    return (
                                        <span key={index}>
                                            <Tag color="blue">{tag}</Tag>
                                        </span>
                                    )
                                })
                            ) : (
                                <div>Không</div>
                            )}
                        </div>
                    </Form.Item>
                    <Form.Item label="Nội dung">
                        <div>
                            {
                                <ReactQuill
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        paddingRight: 30,
                                        borderWidth: 0,
                                    }}
                                    id="divToPrint"
                                    modules={quillModules}
                                    readOnly
                                    value={report.content}
                                />
                            }
                        </div>
                    </Form.Item>
                    <Form.Item label="Người dùng đã xem">
                        {user_has_read.map((user, index) => {
                            return (
                                <Tooltip
                                    placement="rightTop"
                                    title={user.display_name}
                                >
                                    <Avatar
                                        src={
                                            user.avatar === ''
                                                ? defaultAvatar
                                                : user.avatar
                                        }
                                        alt={user.display_name}
                                        key={index}
                                        style={{ marginRight: 5 }}
                                    />
                                </Tooltip>
                            )
                        })}
                    </Form.Item>
                </Form>
                <ListComment />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        selected_Media: state.qbreport.selected_Media,
        selected_object: state.qbreport.selected_object,
        selected_event: state.qbreport.selected_event,
        selected_report: state.qbreport.selected_report,
        hashtag: state.qbreport.hashtag,
        user_has_read: state.qbreport.current_report.user_has_read
            ? state.qbreport.current_report.user_has_read
            : [],
        report: state.qbreport.current_report,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dismiss: () => {
            dispatch(ReportActions.action.dismissModalReportInfo())
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReportInfoView)
